import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import IconNP from "../../../images/icons/nova_post.svg";
import { useRef } from "react";
import { useGetPageUnloadQuery } from "../../../redux/services/noLoadingReqAPI";
import AddresSearchList from "../../searchList/NPSearchLists/AddresSearchList";
import { useSendFormMutation } from "../../../redux/services/crmAPI";
import { errorAlert, succsesDataAddAlert } from "../../../alerts/alerts";
import { payerType } from "./ModalNPData";
import WarehouseSearchList from "../../searchList/NPSearchLists/WarehouseSearchList";
import CitySearchList from "../../searchList/NPSearchLists/CitySearchList";

const ModalNP = ({
    setShowNpModal,
    showNpModal,
    orderId,
    positions,
    totlaPrice,
    clientId,
    refetchOrder,
    clientName,
    clientPhone,
}) => {
    const handleClose = () => setShowNpModal(false);

    const cityRef = useRef();
    const cityInputRef = useRef();
    const warehouseInputRef = useRef();
    const warehouseRef = useRef();
    const addressRef = useRef();
    const addressInputRef = useRef();

    const [showSearchCitiList, setShowSearchCitiList] = useState(false);
    const [showSearchwarehouseList, setShowSearchWarehouseList] = useState(false);
    const [showSearchAddressList, setShowSearchAddressList] = useState(false);

    const [delType, setDelType] = useState(1);
    const [payType, setPayType] = useState(1);
    const [backDelType, setBackPayType] = useState(1);
    const [descr, setDescr] = useState("");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [citi, setCiti] = useState("");
    const [cost, setCost] = useState(0);
    const [returnCost, setReturnCost] = useState(0);
    const [building, setBuilding] = useState("");
    const [warehouse, setWarehouse] = useState("");
    const [address, setAddress] = useState("");
    const [addressRefValue, setAddressRefValue] = useState("");
    const [streetRefValue, setStreetRefValue] = useState("");
    const [cityRefValue, setCityRefValue] = useState("");
    const [deliveryCityRef, setDeliveryCityRef] = useState("");

    const warehouseSearchParams = "&search=" + warehouse;
    const addressSearchParams = "&search=" + address;

    const { data: cities } = useGetPageUnloadQuery("nova-poshta/cities?search=" + citi);
    const { data: streets } = useGetPageUnloadQuery(
        "nova-poshta/streets?city_ref=" + cityRefValue + addressSearchParams
    );
    const { data: warehouses } = useGetPageUnloadQuery(
        "nova-poshta/warehouses?limit=15&page=1&delivery_city_ref=" + deliveryCityRef + warehouseSearchParams
    );
    const [sendForm, { isLoading, isError, error: sendFormError }] = useSendFormMutation();

    const sendFormHandler = async () => {
        const formData = {
            order_id: orderId,
            name: name,
            phone: phone,
            client_id: clientId ? clientId : "",
            payer_type: payerType[payType],
            payment_method: "Cash",
            description: descr,
            cost: +cost,
            return_money: +returnCost,
            address_ref: delType === 1 ? addressRefValue : streetRefValue,
            building: building,
            city_ref: cityRefValue,
        };

        await sendForm({
            body: formData,
            url: "nova-poshta/invoice",
            method: "POST",
        }).unwrap();

        await refetchOrder();

        if (!isError) {
            succsesDataAddAlert();
            setShowNpModal(false);
        }
    };
    useEffect(() => {
        setDescr(positions.map((position) => position.title + " /" + position?.imei).join(" /") + " /icloud clean");
        setName(clientName);
        setPhone(clientPhone);
    }, [positions, clientName, clientPhone]);

    useEffect(() => {
        const outsideHandleClick = (e) => {
            if (
                cityInputRef.current &&
                !e.composedPath().includes(cityInputRef.current) &&
                cityRef.current &&
                !e.composedPath().includes(cityRef.current)
            ) {
                setShowSearchCitiList(false);
            }

            if (
                warehouseInputRef.current &&
                !e.composedPath().includes(warehouseInputRef.current) &&
                warehouseRef.current &&
                !e.composedPath().includes(warehouseRef.current)
            ) {
                setShowSearchWarehouseList(false);
            }
        };

        document.body.addEventListener("click", outsideHandleClick);

        return () => {
            document.body.removeEventListener("click", outsideHandleClick);
        };
    }, []);

    useEffect(() => {
        setCost(totlaPrice);
        setReturnCost(totlaPrice);
    }, [totlaPrice]);

    useEffect(() => {
        if (backDelType === 2) {
            setReturnCost(0);
        } else if (backDelType === 1) {
            setReturnCost(totlaPrice);
        }
    }, [backDelType]);

    useEffect(() => {
        if (sendFormError) {
            errorAlert();
        }
    }, [sendFormError]);

    return (
        <Modal show={showNpModal} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div>
                        <img
                            src={IconNP}
                            alt="NP"
                            style={{ width: "39px", height: "39px", marginRight: "30px", marginTop: "-8px" }}
                        />
                        Електронна Накладна #{orderId}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <>
                    <div className="row">
                        <div className="form-group col-6">
                            <label className="form-label">Тип доставки</label>

                            <div className="d-flex ">
                                <div className="form-check me-3">
                                    <input
                                        type="radio"
                                        name="radioType"
                                        className="form-check-input"
                                        checked={delType === 1 ? true : false}
                                        onChange={(e) => setDelType(e.target.value ? 1 : 2)}
                                    />
                                    <label className="form-check-label" for="radioType1">
                                        У відділення
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        name="radioType"
                                        className="form-check-input"
                                        checked={delType === 2 ? true : false}
                                        onChange={(e) => setDelType(e.target.value ? 2 : 1)}
                                    />
                                    <label className="form-check-label" for="radioType2">
                                        По адресу
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-6">
                            <label className="form-label">Доставку оплачує</label>
                            <div className="d-flex ">
                                <div className="form-check me-3">
                                    <input
                                        type="radio"
                                        name="radioDelivery"
                                        className="form-check-input"
                                        checked={payType === 1 ? true : false}
                                        onChange={(e) => setPayType(e.target.value ? 1 : 2)}
                                    />
                                    <label className="form-check-label" for="radioDelivery1">
                                        Відправник
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        name="radioDelivery"
                                        className="form-check-input"
                                        checked={payType === 2 ? true : false}
                                        onChange={(e) => setPayType(e.target.value ? 2 : 1)}
                                    />
                                    <label className="form-check-label" for="radioDelivery2">
                                        Отримувач
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="form-group col-6">
                            <label className="form-label">Місто</label>
                            <input
                                type="text"
                                value={citi}
                                onChange={(e) => setCiti(e.target.value)}
                                className="form-control"
                                autocomplete="off"
                                ref={cityInputRef}
                                onFocus={() => setShowSearchCitiList(true)}
                            />
                            <div ref={cityRef}>
                                {cities?.data[0] && showSearchCitiList && citi && (
                                    <CitySearchList
                                        data={cities.data[0].Addresses}
                                        onSelectDataHandler={setCiti}
                                        setShowList={setShowSearchCitiList}
                                        setDeliveryRefValue={setDeliveryCityRef}
                                        setCityRefValue={setCityRefValue}
                                    />
                                )}
                            </div>
                        </div>

                        {delType === 1 ? (
                            <div className={"form-group col-6 address_label"}>
                                <label className="form-label">Відділення</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    autocomplete="off"
                                    value={warehouse}
                                    onChange={(e) => setWarehouse(e.target.value)}
                                    ref={warehouseInputRef}
                                    onFocus={() => setShowSearchWarehouseList(true)}
                                />
                                <div ref={warehouseRef}>
                                    {warehouses?.data && showSearchwarehouseList && warehouse && (
                                        <WarehouseSearchList
                                            data={warehouses.data}
                                            onSelectDataHandler={setWarehouse}
                                            setShowList={setShowSearchWarehouseList}
                                            setAddressRefValue={setAddressRefValue}
                                        />
                                    )}
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className={"form-group col-4 address_label"}>
                                    <label className="form-label">Адреса</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        autocomplete="off"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        ref={addressInputRef}
                                        onFocus={() => setShowSearchAddressList(true)}
                                    />
                                    <div ref={addressRef}>
                                        {streets?.data[0] && showSearchAddressList && address && (
                                            <AddresSearchList
                                                data={streets.data[0].Addresses}
                                                setAddress={setAddress}
                                                setShowList={setShowSearchAddressList}
                                                setAddressRefValue={setAddressRefValue}
                                                setStreetRefValue={setStreetRefValue}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="form-group col-2 address_label">
                                    <label className="form-label">Будинок</label>
                                    <input
                                        type="text"
                                        name="__warehouse"
                                        className="form-control"
                                        autocomplete="off"
                                        value={building}
                                        onChange={(e) => setBuilding(e.target.value)}
                                    />
                                </div>
                            </>
                        )}

                        <div className="form-group col-2 house_label d-none">
                            <label>Будинок</label>
                            <input type="text" name="__house" className="form-control" value="" readonly="" />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="form-group col-6">
                            <label className="form-label">Оголошена вартість (грн.)</label>
                            <input
                                type="number"
                                name="__total_price"
                                value={cost}
                                onChange={(e) => setCost(e.target.value)}
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-6">
                            <label className="text-danger form-label">Зворотня доставка</label>

                            <div className="input-group ">
                                <div className="input-group-text">
                                    <div className="form-check me-3">
                                        <input
                                            type="radio"
                                            name="radioBack"
                                            className="form-check-input"
                                            checked={backDelType === 1 ? true : false}
                                            onChange={(e) => setBackPayType(e.target.value ? 1 : 2)}
                                        />
                                        <label className="form-check-label" for="radioBack1">
                                            Так
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            name="radioBack"
                                            className="form-check-input"
                                            checked={backDelType === 2 ? true : false}
                                            onChange={(e) => setBackPayType(e.target.value ? 2 : 1)}
                                        />
                                        <label className="form-check-label" for="radioBack2">
                                            Ні
                                        </label>
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    value={returnCost}
                                    onChange={(e) => setReturnCost(e.target.value)}
                                    className="form-control"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="form-group col-6">
                            <label className="form-label">Отримувач</label>
                            <input
                                type="text"
                                name="__name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-6">
                            <label className="form-label">Телефон</label>
                            <input
                                type="text"
                                name="__phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="form-group mt-3">
                        <label className="form-label">Опис відправлення</label>
                        <textarea
                            className="form-control"
                            name="__description"
                            data-dl-input-translation="true"
                            value={descr}
                            onChange={(e) => setDescr(e.target.value)}
                        ></textarea>
                    </div>
                </>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={sendFormHandler}>
                    {isLoading ? "Опрацювання" : "Створити накладну"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalNP;
